import { render } from "./WhatsAppManagement.vue?vue&type=template&id=fce4f0aa&scoped=true"
import script from "./WhatsAppManagement.vue?vue&type=script&lang=js"
export * from "./WhatsAppManagement.vue?vue&type=script&lang=js"

import "./WhatsAppManagement.vue?vue&type=style&index=0&id=fce4f0aa&scoped=true&lang=css"
import "./WhatsAppManagement.vue?vue&type=style&index=1&id=fce4f0aa&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce4f0aa"]])

export default __exports__